{
	"accept": {
		"cancel": "Annulla",
		"confirm_one": "Sì, accetta la riga",
		"confirm_other": "Sì, accetta {{rows}} righe",
		"confirm_view_description_one": "L’altra riga del documento non viene toccata. Le righe già corrette non cambiano e l’azione resta tracciata nello storico.",
		"confirm_view_description_other": "Le altre {{others}} righe del documento non vengono toccate. Le righe già corrette non cambiano e l’azione resta tracciata nello storico.",
		"confirm_view_title_one": "Accettare la riga di questa vista?",
		"confirm_view_title_other": "Accettare le {{rows}} righe di questa vista?",
		"confirm_whole_description_one": "Verrà accettata l’ultima riga ancora da rivedere, anche se segnalata. L’azione resta tracciata nello storico.",
		"confirm_whole_description_other": "Verranno accettate tutte le {{rows}} righe ancora da rivedere, comprese quelle segnalate. L’azione resta tracciata nello storico.",
		"confirm_whole_title_one": "Accettare l’ultima riga da rivedere?",
		"confirm_whole_title_other": "Accettare tutte le {{rows}} righe da rivedere?",
		"view_button": "Accetta questa vista ({{rows}})",
		"whole_button": "Accetta tutto ({{rows}})"
	},
	"breakdown": {
		"title": "Il calcolo, passo per passo"
	},
	"calc": {
		"hide_basis": "Nascondi la provenienza",
		"show_basis": "Da dove escono questi numeri"
	},
	"config": {
		"effect_notice": "Le modifiche hanno effetto dalle proposte successive: i documenti già generati non cambiano.",
		"example_label": "Esempio",
		"history_entry": "Configurazione salvata",
		"history_load_more": "Carica di più",
		"history_system": "Modifica automatica",
		"history_title": "Storia delle modifiche",
		"invalid_number": "Inserisci un numero valido.",
		"invalid_percentage": "Inserisci una percentuale tra 0 e 100.",
		"no_changes": "Nessuna modifica da salvare",
		"page_title": "Configurazione",
		"remove": "Rimuovi",
		"safety_default": "Scorta standard",
		"safety_description": "Copie ordinate in più rispetto alla previsione di vendita, per non restare senza. È un compromesso: più scorta riduce il rischio di restare senza copie ma aumenta l’invenduto; meno scorta fa il contrario. «Standard» vale per tutti gli editori normali, «Esclusive» per gli editori in conto deposito (dove l’invenduto si può restituire, quindi conviene tenerne di più).",
		"safety_esclusiva": "Scorta per esclusive",
		"safety_example": "Previsione 200 copie con scorta 3% → si ordinano 206 copie.",
		"safety_title": "Scorte di sicurezza",
		"save": "Salva configurazione",
		"sections_label": "Sezioni della configurazione",
		"tuning": {
			"adoption_description": "Come le sezioni che adottano un titolo diventano copie da ordinare. Non c’è un numero unico: da una sezione adottante Mantegna assorbe 6,6 copie nel Lazio e 0,66 in Campania, e dentro la stessa regione cambia da editore a editore (Zanichelli in Campania 0,20, Petrini 3,44). Il motore quindi somma le sezioni regione per regione, ognuna al suo valore reale per quell’editore e quella tipologia scolastica: lo stesso conto che si fa a mente guardando dove si vende davvero. La «prudenza» evita che una coppia regione/editore con pochissime adozioni faccia testo da sola: sotto quelle sezioni di storico conta anche il dato medio della regione. I due limiti sono una rete di sicurezza sui casi estremi.",
			"adoption_example": "Un titolo con 226 sezioni nel Lazio e 572 in Campania non vale 798 × la media nazionale, ma 226 × 9,43 più 572 × 3,61.",
			"adoption_title": "Adozioni scolastiche",
			"adoptionBookingCap": "Proiezione massima del prenotato (0 = spenta)",
			"adoptionBookingMin": "Copie prenotate minime per proiettare",
			"adoptionCellPrior": "Prudenza sui dati sottili (sezioni)",
			"adoptionRegionWeighting": "Valuta le sezioni zona per zona",
			"adoptionWeightMax": "Scarto massimo ammesso dalla media",
			"adoptionWeightMin": "Scarto minimo ammesso dalla media",
			"adottatoHistoryThreshold": "Copie proprie sotto cui affidarsi all’adozione",
			"age": "{{n}} anni",
			"blend_description": "Come le vendite reali di quest’anno correggono la previsione fatta sullo storico. Funziona in due direzioni. Al rialzo, sempre: un titolo che ha già venduto più della sua previsione viene subito rialzato (le copie già vendute sono un minimo certo). Il «rialzo massimo» limita quanto si proietta il già venduto a fine anno, e si riduce da solo man mano che la stagione avanza. Al ribasso, con prudenza: la previsione viene abbassata verso il ritmo reale solo quando è trascorsa abbastanza stagione («stagione minima trascorsa»), perché a inizio stagione un venduto basso non significa calo. La «forza della correzione» regola quanto pesa il ritmo reale.",
			"blend_example": "Un titolo con previsione 49 che ha già venduto 1.400 copie a luglio viene rialzato a ~2.800; uno che a luglio ha venduto poco resta alla previsione storica.",
			"blend_title": "Correzione con le vendite di quest’anno",
			"blendK": "Forza della correzione",
			"blendMinElapsed": "Stagione trascorsa prima di attivarla",
			"campaignAnticipoShare": "Quota di anticipo campagna (0-1)",
			"coexistMinYearGap": "Anni minimi tra due edizioni per segnalare un doppione (0 = spento)",
			"edizioneRecenteMaxAge": "Anni massimi dall’uscita",
			"edizioneRecenteMinVol": "Copie già vendute (minimo)",
			"exclusivityFactorMax": "Fattore massimo per un'esclusiva acquisita (3 = fino a ×3)",
			"exclusivityFactorMin": "Fattore minimo per un'esclusiva persa (0-1, 0,1 = fino a −90%)",
			"fitMinBase": "Copie minime per usare un titolo nei calcoli",
			"leadTimeDays": "Giorni di consegna del fornitore",
			"lot_add_step": "Aggiungi gradino",
			"lot_description": "Arrotonda le quantità proposte a numeri ordinabili sensati, per evitare cifre come 47 o 183 scomode da gestire. Sotto la soglia «la lascio esatta» la quantità non viene toccata (poche copie, meglio precise); sopra quella soglia, viene arrotondata a seconda di quanto è grande l’ordine. Le regole dicono «fino a quale quantità» usare «quale arrotondamento»: gli ordini piccoli si arrotondano a numeri piccoli, quelli grandi a numeri più grossi.",
			"lot_example": "Con le regole predefinite, 47 diventa 50, 138 diventa 150, 640 diventa 650.",
			"lot_step_final": "oltre",
			"lot_step_step": "Passo",
			"lot_step_upto": "Fino a",
			"lot_steps_label": "Regole di arrotondamento",
			"lot_title": "Arrotondamento delle quantità",
			"lotExactBelow": "Sotto questa quantità la lascio esatta",
			"lotMinRecurring": "Confezione minima",
			"recent_description": "Riconosce i titoli usciti da poco, che non hanno ancora abbastanza storico per una previsione affidabile. Un titolo viene marcato come «appena uscito» quando la sua edizione è più giovane degli anni massimi indicati e ha già superato le copie minime vendute: abbastanza nuovo da trattarlo come un debuttante, ma con vendite sufficienti a meritare attenzione.",
			"recent_example": "Un titolo uscito l’anno scorso che ha già venduto 150 copie viene marcato come appena uscito.",
			"recent_title": "Titoli appena usciti",
			"regimes_description": "Come si dividono i due tipi di documento. Il documento «campagna» anticipa la stagione: propone la quota indicata del fabbisogno annuo residuo (1 = tutto l’anno in un colpo, 0,5 = metà adesso e il resto coi riordini). Il documento «riordino» copre i prossimi giorni di domanda stagionale (il periodo si sceglie alla creazione; qui il valore usato quando non indicato) PIÙ i giorni di consegna del fornitore: se la merce impiega 10 giorni ad arrivare, l’ordine di oggi deve coprire anche quell’attesa. Eccezione: un titolo nuovo adottato, nel riordino, copre la partenza della stagione finché le copie caricate quest’anno e quelle in arrivo non ci arrivano, cioè tutta la stagione se l’editore è in esclusiva e la quota indicata negli altri casi. In più copre sempre le copie già richieste dai clienti (ordini aperti, arretrati, prenotazioni). Gli ordini fatti al fornitore si vedono dai carichi in Mr.Book al sync successivo.",
			"regimes_example": "A fine luglio un riordino a 14 giorni copre l’inizio del picco di agosto; lo stesso a febbraio proporrebbe quasi zero.",
			"regimes_title": "Campagna e riordini",
			"reorderHorizonDays": "Giorni coperti da un riordino",
			"reorderNewTitleShare": "Quota di stagione per i titoli nuovi adottati (0-1)",
			"retCeil": "Rivendita massima (limita anche adozioni e passaggio di classe)",
			"retention_description": "Indica quante delle copie vendute l’anno scorso ci si aspetta di rivendere quest’anno, a seconda di quanto è vecchia l’edizione. Il valore 1,00 vuol dire «stesse vendite dell’anno scorso», sopra 1 vuol dire in crescita, sotto 1 in calo: i titoli appena usciti (0-1 anni) possono ancora crescere, poi la quota cala col passare degli anni. La «rivendita edizioni vecchie» vale dagli 11 anni in su o quando l’anno di edizione non è noto; «minima» e «massima» sono i limiti oltre cui la stima non può andare. La «massima» vale anche come tetto alla crescita delle sezioni adottanti e al passaggio di un titolo dal volume precedente.",
			"retention_example": "Un’edizione di 3 anni con quota 0,80 che l’anno scorso vendette 100 copie porta a una previsione di partenza di 80 copie.",
			"retention_title": "Quanto si rivende l’anno dopo",
			"retFloor": "Rivendita minima",
			"retMature": "Rivendita edizioni vecchie (oltre 10 anni)",
			"scorrimentoMaxOwn": "Copie proprie sotto cui affidarsi al volume precedente",
			"scorrimentoRecoverMin": "Copie del volume precedente per ereditarne la stima",
			"segClipHigh": "Correzione massima",
			"segClipLow": "Correzione minima",
			"segment_description": "Corregge la previsione in base a come sta andando l’intero settore di Mr.Book, cioè il gruppo editoriale o distributore (De Agostini, Mondadori, Zanichelli…): se i titoli di un settore vendono più o meno di quanto direbbe la sola età dell’edizione, vengono ritoccati di conseguenza. Si applica solo ai settori con abbastanza vendite da essere affidabili, e la correzione è tenuta tra un minimo e un massimo per evitare esagerazioni.",
			"segment_example": "Se i titoli di un gruppo editoriale vendono il 20% in più del previsto, un suo titolo con previsione 100 sale a 120 (fino al tetto della correzione massima).",
			"segment_title": "Correzione per settore (gruppo editoriale)",
			"segMinVol": "Copie minime del settore per correggere",
			"succActiveMin": "Copie minime del possibile sostituto",
			"succCollapseRatio": "Soglia di crollo delle vendite",
			"succDeclineFromMin": "Copie vendute un tempo (minimo)",
			"succession_description": "Individua i titoli ormai sostituiti da una nuova edizione, per non riordinare copie superate. Un titolo viene segnalato quando: vendeva bene in passato (sopra le copie minime indicate), poi è crollato oltre la soglia di crollo, ed esiste un titolo molto simile dello stesso editore, della stessa classe, ancora in vendita, che è il suo sostituto naturale. In quel caso riceve la segnalazione «Verifica edizione» con quantità azzerata: non viene riordinato da solo, decidi tu. In più, se due edizioni dello stesso titolo distano almeno gli «anni minimi per doppione» ed entrambe risultano attive, la più vecchia riceve la segnalazione «Edizione doppia»: la sua quantità viene ridimensionata sulle adozioni che le restano, e azzerata se non ne ha più.",
			"succession_example": "«Matematica.blu vol.2 (2019)» vendeva 200 copie, ora 30, e c’è «Matematica.blu vol.2 (2024)» dello stesso editore ancora in vendita → segnalato come sostituito.",
			"succession_title": "Riconoscimento di una nuova edizione",
			"succSimMin": "Somiglianza minima tra i due titoli",
			"universe_description": "Decide quali titoli entrano nella proposta e come vengono recuperati quelli che non hanno ancora vendite proprie. Entra ogni titolo ordinabile che ha venduto l’anno scorso, che è adottato, che ha un volume precedente che vende, o che ha ordini clienti non coperti da giacenza e arrivi. Restano fuori i titoli fuori catalogo o bloccati, le voci contabili e la cartoleria. Questi valori stabiliscono quando un titolo con poche vendite proprie viene stimato partendo dal volume della classe precedente oppure dall’adozione scolastica. Le «copie minime per usare un titolo nei calcoli» servono a escludere i titoli troppo piccoli, che altrimenti falserebbero le medie.",
			"universe_example": "Un volume 2 con 0 copie proprie, il cui volume 1 ne vendette 300 l’anno scorso, viene comunque proposto ereditando la stima dal volume precedente.",
			"universe_title": "Quali titoli ordinare",
			"ytdFloorCap": "Rialzo massimo sul già venduto (0 = spento)"
		},
		"unsaved": "Modifiche non salvate"
	},
	"correct": {
		"confirm": "Salva correzione",
		"from": "Attuale",
		"note_help": "Spiega perché stai correggendo la proposta. Le note vengono raccolte come feedback e usate per migliorare l'algoritmo che genera le proposte d'ordine.",
		"note_label": "Note (obbligatorie)",
		"note_placeholder": "Es. adozione non confermata, ordino di meno…",
		"quick": {
			"adozione": "Adozione non confermata",
			"capo_ciclo": "Capo ciclo: aspetto l'adottato",
			"cappottato": "Titolo cambiato dall'editore",
			"gia_coperto": "Già coperto dal prenotato",
			"non_uscito": "Libro non ancora uscito",
			"zona": "Non è una mia zona"
		},
		"same_as_proposal": "La correzione deve essere diversa dalla quantità proposta.",
		"system_proposal": "Proposta originale del sistema: {{qty}}",
		"title": "Conferma correzione",
		"to": "Nuova",
		"too_large": "La quantità supera il massimo consentito ({{max}}): hai incollato un codice?"
	},
	"dashboard": {
		"agent": "Collegamento con Mr.Book",
		"agent_full_label": "Ultimo aggiornamento completo",
		"agent_name_label": "Agente",
		"agent_seen_label": "Ultimo contatto",
		"confirmed_heading": "Verificata il",
		"current_campaign": "Campagna {{year}}",
		"data_freshness": "Freschezza dei dati",
		"dataset_label": "Dati di Mr.Book al",
		"never": "mai",
		"newer_version_pending": "Versione più recente in arrivo",
		"newer_version_pending_hint": "È già arrivata una versione più recente di questa tabella: i documenti la useranno quando finisce l’aggiornamento.",
		"no_agent_hint": "Il programma di sincronizzazione non è ancora installato sul PC di Mr.Book.",
		"no_run_hint": "Quando i dati saranno arrivati, potrai generare il primo documento dalla sezione Documenti PO.",
		"no_run_yet": "Nessun documento generato finora",
		"open_document": "Apri il documento",
		"refresh_done": "Dati aggiornati",
		"refresh_incomplete": "Aggiornamento non riuscito",
		"refresh_incomplete_tables": "Aggiornamento non riuscito per: {{list}}",
		"refresh_now": "Aggiorna dati ora",
		"refresh_stalled": "L'agente non ha risposto all'ultima richiesta",
		"refresh_syncing": "Sincronizzazione in corso",
		"run_failed": "La generazione di questo documento è fallita. Apri il documento per i dettagli.",
		"stale_close": "Chiudi avviso",
		"stale_warning": "Attenzione: stai guardando dati di {{days}} giorni fa. Il sistema resta utilizzabile, ma le quantità potrebbero non riflettere le vendite più recenti.",
		"sync_in_progress": "Aggiornamento in corso",
		"table_behind": "Non aggiornata con le altre tabelle: i documenti la usano com’era a questa data.",
		"table_failed": "Ultimo aggiornamento non riuscito: {{reason}}",
		"table_failed_no_reason": "Ultimo aggiornamento non riuscito",
		"table_stale_hint": "Questa tabella non viene verificata da più di un giorno.",
		"tables_heading": "Tabelle usate dai documenti",
		"trust_fresh": "Dati aggiornati al {{date}}: sono quelli che userà il prossimo documento.",
		"waiting_first_data": "Stiamo aspettando i primi dati da Mr.Book: arrivano da soli alle 12 e a mezzanotte."
	},
	"dataset": {
		"missing_required": "Mancano dati indispensabili di Mr.Book: {{list}}. Finché non arrivano non si possono generare documenti.",
		"table_behind": "I dati di {{table}} sono fermi al {{date}}.",
		"unresolved": "I dati di {{list}} vanno rispediti da Mr.Book: chiedi al supporto un aggiornamento completo. Finché non arrivano, i documenti non li usano."
	},
	"detail": {
		"accept": "Accetta la proposta",
		"adoption_regions": "Adozioni per regione",
		"adoption_regions_hint": "Dove sono le sezioni che hanno adottato il titolo. Il peso zone alza o abbassa la stima in base a quanto Mantegna è forte in quelle regioni.",
		"close": "Chiudi il dettaglio",
		"copies_proposed": "copie proposte",
		"correct_label": "Quantità da ordinare",
		"correct_submit": "Correggi",
		"corrected_to": "la tua correzione",
		"decision": "La tua decisione",
		"history": "Cronologia di questa riga",
		"history_empty": "Nessuna decisione ancora su questa riga.",
		"past_campaigns": "Campagne passate su questo titolo",
		"past_decision": "proposto {{proposed}} → deciso {{decided}}",
		"past_not_reviewed": "proposto {{proposed}} · non revisionata",
		"reasoning": "Perché questo numero"
	},
	"detail_breadcrumb": "Documento",
	"detail_page": {
		"adottato_missing": "Le adozioni di quest'anno non erano ancora in Mr.Book quando questo documento è stato generato: il contributo adozioni non è incluso.",
		"failed_title": "La generazione è fallita",
		"failed_unknown": "Errore sconosciuto",
		"generating": "Sto calcolando le proposte titolo per titolo. La pagina si aggiorna da sola: tra pochi istanti comparirà la griglia.",
		"generating_title": "Sto generando il documento",
		"signals_missing": "In questo documento mancano dati di Mr.Book: {{list}}. Il motore li ha letti come zero o li ha stimati: le quantità possono essere sbagliate.",
		"simulation_banner": "Questo è un documento di SIMULAZIONE a magazzino vuoto: le giacenze sono state azzerate per valutare il ragionamento. Non usarlo come ordine reale."
	},
	"export": {
		"active_filters": "Filtri attivi",
		"description": "Il file riflette le revisioni fatte finora, correzioni incluse, e contiene solo le righe che passano i filtri attivi qui sotto.",
		"disabled_simulation": "Le simulazioni a magazzino vuoto non si esportano: genera un documento normale.",
		"failed": "L'export non è riuscito: riprova tra qualche minuto.",
		"filter_distributor": "Distributore",
		"filter_publisher": "Editore",
		"filter_review": "Revisione",
		"filter_school_type": "Tipologia",
		"filter_search": "Ricerca",
		"generate": "Genera l'export",
		"generating": "Sto generando…",
		"no_filters": "Nessun filtro attivo: l'export contiene tutto il documento.",
		"ready": "Export pronto: il download parte da solo",
		"remove_filter": "Rimuovi il filtro {{filter}}",
		"still_generating": "L'export è in generazione: tra poco lo trovi nella scheda Storico export del documento",
		"title": "Esporta ordini"
	},
	"exports": {
		"all_statuses": "Tutti gli stati",
		"columns": {
			"actions": "Azioni",
			"document": "Documento",
			"generated_at": "Generato il",
			"id": "ID",
			"status": "Stato",
			"summary": "Contenuto"
		},
		"completed": "Pronto",
		"download_csv": "Scarica CSV",
		"download_xlsx": "Scarica Excel",
		"empty_description": "Gli export si generano dal documento di proposta.",
		"empty_document_description": "Da questo documento non hai ancora generato nessun export.",
		"empty_title": "Nessun export",
		"failed": "Fallito",
		"pending": "In generazione",
		"summary_line": "{{titles}} titoli · {{copies}} copie · {{publishers}} editori"
	},
	"grid": {
		"accept_short": "Accetta",
		"adoptions_title": "Sezioni che adottano il titolo: campagna scorsa e campagna in corso. Il trend è il segnale: un crollo annuncia un cambio di edizione. Clicca il numero per le regioni.",
		"all_distributors": "Tutti i distributori",
		"all_publishers": "Tutti gli editori",
		"all_reviews": "Tutti gli stati",
		"all_school_types": "Tutte le tipologie",
		"available_title": "Stock vendibile ora: giacenza meno le copie riservate (Pren.Disp + Lista di prelievo). Coincide con la Disponibilità di Mr.Book",
		"bulk_accept": "Accetta {{count}} righe",
		"bulk_accepted_one": "1 riga accettata",
		"bulk_accepted_other": "{{count}} righe accettate",
		"columns": {
			"adoptions": "Adozioni",
			"code": "ISBN",
			"corrected": "Corretta",
			"note": "Note",
			"pred_sold": "Venduto vol. prec.",
			"proposed": "Proposta",
			"school_type": "Tipologia",
			"sold_history": "Venduto",
			"status": "Stato",
			"stock": "Disponibile",
			"stock_real": "Giacenza",
			"title": "Titolo"
		},
		"copied": "Copiato!",
		"empty_description": "Nessuna riga corrisponde ai filtri selezionati.",
		"empty_title": "Nessun risultato",
		"mrbook_code": "cod. {{code}}",
		"no_predecessor": "Nessun volume precedente",
		"not_bulk_selectable": "Riga già rivista: non serve riaccettarla.",
		"pred_sold_title": "Venduto del volume precedente (la classe prima di questa) negli ultimi 3 anni: la base per giudicare uno scorrimento.",
		"search_placeholder": "Cerca per titolo, ISBN o codice…",
		"sold_history_title": "Venduto degli ultimi 3 anni, dal più vecchio al più recente: gli stessi contatori dello «Storico anni prec.» della scheda Mr.Book. La colonna ordina per l'anno più recente.",
		"stock_title": "Giacenza reale a magazzino: esistenza di inizio anno più i carichi, meno scarichi e resi dell’anno"
	},
	"history": {
		"bulk_accepted": "Accettata (in blocco)",
		"proposal_accepted": "Accettata",
		"proposal_corrected": "Quantità corretta",
		"proposal_feedback": "Nota aggiunta"
	},
	"index": {
		"all_statuses": "Tutti gli stati",
		"columns": {
			"campaign": "Campagna",
			"created_at": "Creata il",
			"id": "ID",
			"name": "Nome",
			"review_progress": "Revisione",
			"status": "Stato",
			"updated_at": "Ultima modifica",
			"updated_at_hint": "L’ultimo lavoro sul documento: generazione, decisioni sulle righe, nome o stato. È l’ordine predefinito dell’elenco, dal più recente."
		},
		"dataset_as_of": "Il documento userà i dati di Mr.Book aggiornati al {{date}}.",
		"dataset_date": "Il documento userà i dati di Mr.Book del {{date}}.",
		"dataset_not_ready": "Mancano dati indispensabili di Mr.Book: il documento non si può generare finché non arrivano.",
		"dataset_syncing": "Aggiornamento in corso: il documento userà i dati del {{date}}. Se ti servono quelli nuovi, aspetta che l’aggiornamento finisca.",
		"dataset_unavailable": "Non riesco a leggere la data dei dati di Mr.Book: il documento userà comunque l’ultimo aggiornamento completo.",
		"distributors_all": "Tutti i distributori",
		"distributors_clear_all": "Deseleziona tutto",
		"distributors_no_match": "Nessun distributore corrisponde alla ricerca.",
		"distributors_search_placeholder": "Cerca un distributore…",
		"distributors_select_all": "Seleziona tutto",
		"distributors_selected_count": "{{count}} selezionati",
		"distributors_title": "Distributori",
		"empty_description": "Genera la tua prima proposta d'ordine per iniziare.",
		"empty_title": "Nessun documento",
		"generate_document": "Genera il documento",
		"generation_started": "Generazione avviata: il documento si aggiornerà da solo",
		"horizon_biweekly": "Ogni due settimane",
		"horizon_daily": "Ogni giorno",
		"horizon_monthly": "Ogni mese",
		"horizon_weekly": "Ogni settimana",
		"mode_campagna": "Campagna",
		"mode_campagna_hint": "Il piano dell’intera stagione: il fabbisogno dell’anno residuo, da rivedere titolo per titolo e ordinare a tranche.",
		"mode_riordino": "Riordino",
		"new_document": "Nuovo documento",
		"new_document_explainer": "Il documento nasce dai dati di Mr.Book e va rivisto titolo per titolo.",
		"no_complete_dataset": "Non ci sono ancora dati completi da Mr.Book, quindi il documento non si può generare. Premi «Aggiorna dati ora» nella Dashboard e riprova quando l’aggiornamento è finito.",
		"no_complete_dataset_syncing": "Non ci sono ancora dati completi da Mr.Book: potrai generare il documento quando l’aggiornamento in corso sarà finito.",
		"reorder_group": "Ogni quanto fai gli ordini",
		"reorder_note": "Copre le vendite del periodo più i {{lead}} giorni di consegna, e le copie dovute ai clienti: sei coperto fino al {{date}}.",
		"reviewed_of": "{{reviewed}} / {{total}}",
		"search_placeholder": "Cerca per nome…",
		"simulation_hint": "Ogni giacenza letta come zero, documento non esportabile.",
		"simulation_label": "Simulazione a magazzino vuoto",
		"tables_behind_effect": "Le quantità possono non tenere conto di quello che è cambiato in Mr.Book da allora.",
		"update_failed": "L’ultimo aggiornamento non è riuscito per: {{list}}. Il documento userà i dati arrivati prima."
	},
	"page_title": "Documenti PO",
	"rename": {
		"save": "Salva il nome",
		"saved": "Nome aggiornato",
		"title": "Rinomina"
	},
	"review": {
		"accepted": "Accettata",
		"corrected": "Corretta",
		"pending": "Da rivedere"
	},
	"school_type": {
		"elementari": "Elementari",
		"medie": "Medie",
		"superiori": "Superiori",
		"varia": "Varia"
	},
	"status": {
		"archived": "Archiviato",
		"completed": "Completato",
		"failed": "Fallita",
		"in_progress": "In lavorazione",
		"pending": "In coda",
		"running": "In generazione"
	},
	"tabs": {
		"exports": "Storico export",
		"proposals": "Proposte"
	},
	"workflow": {
		"archive": "Archivia",
		"archive_confirm": "Archivia il documento",
		"archive_confirm_description": "Il documento esce dal lavoro corrente e resta consultabile in sola lettura. Non potrà più essere ripristinato.",
		"archive_confirm_description_wip": "Il documento è ancora in lavorazione: archiviandolo le proposte restano com’è ora, in sola lettura, e non potrà più essere ripreso né completato. Per rilavorarlo dovrai generare un documento nuovo.",
		"archive_confirm_title": "Archiviare questo documento?",
		"cancel": "Annulla",
		"complete": "Completa documento",
		"complete_blocked": "Restano {{count}} righe da rivedere: rivedile tutte per poter completare il documento.",
		"complete_confirm": "Completa il documento",
		"complete_confirm_description": "Il documento resta consultabile ed esportabile, ma le righe non saranno più modificabili e non potrà essere riaperto. Per rilavorarlo dovrai generare un documento nuovo.",
		"complete_confirm_title": "Completare questo documento?",
		"moved_to_archived": "Documento archiviato",
		"moved_to_completed": "Documento completato",
		"transition_refused": "Il documento era già cambiato, forse in un’altra scheda: ora vedi il suo stato attuale."
	},
	"workspace": {
		"copies": "Copie proposte",
		"dataset_as_of": "Dati di Mr.Book al {{date}}",
		"dataset_as_of_hint": "Il documento è stato generato su questi dati: un aggiornamento arrivato dopo non lo cambia.",
		"flagged": "Segnalate",
		"progress": "Revisione",
		"table_behind": "Dati di {{table}} fermi al {{date}}",
		"table_behind_hint": "Questa tabella non era arrivata con l’aggiornamento usato dal documento: le quantità possono non tenere conto di quello che è cambiato dopo in Mr.Book.",
		"to_review": "Da rivedere",
		"to_review_inline": "{{n}} da rivedere",
		"universe": "Titoli"
	}
}
